import { useParams } from "react-router-dom";
import EditTaskForm from "../components/tasks/EditTaskForm";
import { useGetTaskQuery } from "../features/tasks/TasksApi";

export default function EditTask() {
	const { taskId } = useParams();

	const { data: task, isLoading, isError } = useGetTaskQuery(taskId) || {};

	let content = null;
	if (isLoading) {
		content = <div>Loading...</div>;
	} else if (!isLoading && isError) {
		content = <div>There was an error!</div>;
	} else if (!isLoading && !isError && task === undefined) {
		content = <div>No task found!</div>;
	} else if (!isLoading && !isError && task !== undefined) {
		content = <EditTaskForm task={task} />;
	} else {
		content = <div>Something went wrong!</div>;
	}

	return (
		<main className="relative z-20 max-w-3xl mx-auto rounded-lg xl:max-w-none">
			<h1 className="mt-4 mb-8 text-3xl font-bold text-center text-gray-800">
				Create Task for Your Team
			</h1>

			<div className="justify-center mb-10 space-y-2 md:flex md:space-y-0">
				{content}
			</div>
		</main>
	);
}
